/**
 * This Component is intentionally light. It exists separately
 * to ease server side rendering.
 */
import React from 'react';
import App from './App';

class Routes extends React.Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		return <App />;
	}
}

export default Routes;
